import React from "react";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
  TimelineDot,
} from "@mui/lab";

const { theme, styled } = getStyled();

const TimelineStyled = styled(Timeline)(() => ({
  "& .MuiTimelineOppositeContent-root": {
    flex: 0,
    padding: 0,
  },
}));

const TimelineDotStyled = styled(TimelineDot)(({ theme, bgcolor }) => ({
  backgroundColor:
    (bgcolor && theme.palette[bgcolor].main) ?? theme.palette.grey500.main,
  width: theme.spacing(4),
  height: theme.spacing(4),
  alignItems: "center",
  justifyContent: "center",
}));

const TimelineConnectorStyled = styled(TimelineConnector)(
  ({ theme, dashed }) => ({
    width: 0,
    backgroundColor: "transparent",
    borderLeft: `2px ${dashed === "true" ? "dashed" : "solid"} ${
      theme.palette.grey250.main
    }`,
  })
);

const SFBullets = ({ bullets = [], dashed = true }) => {
  return (
    <TimelineStyled>
      {bullets.map((bullet, index) => (
        <TimelineItem key={index}>
          <TimelineOppositeContent />
          <TimelineSeparator dashed={dashed.toString()}>
            <TimelineDotStyled bgcolor={bullet.color}>
              {bullet.icon}
            </TimelineDotStyled>
            {index < bullets.length - 1 && <TimelineConnectorStyled />}
          </TimelineSeparator>
          <TimelineContent>{bullet.element}</TimelineContent>
        </TimelineItem>
      ))}
    </TimelineStyled>
  );
};

SFBullets.propTypes = {
  dashed: PropTypes.bool,
  bullets: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.element.isRequired,
      color: [...Object.keys(theme.palette)],
      element: PropTypes.element.isRequired,
    })
  ),
};

export default SFBullets;
